import React from 'react';
import { Box } from '@mui/material';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface Props {
  size?: number;
  bgColor?: string;
  iconColor?: string;
  sx?: SxProps<Theme>;
}

const TrendingUpIcon = ({
  size = 48,
  bgColor = '#F8FBFD',
  iconColor = '#187CB8',
  sx,
}: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: bgColor,
        color: iconColor,
        display: 'inline-flex',
        height: size,
        justifyContent: 'center',
        width: size,
        ...sx,
      }}
    >
      <TrendingUpOutlinedIcon sx={{ fontSize: Math.round(size * 0.5) }} />
    </Box>
  );
};

export default TrendingUpIcon;
